import {TextInput} from '@primer/react'
import {useState} from 'react'

import {Section} from '../Section'
import {SectionHeader} from '../SectionHeader'
import fieldEditorsStyles from './FieldEditors.module.css'

type IssueFieldCommentEditorProps = {fieldId: string; fieldName: string; readonly: boolean; hideDivider: boolean}

type IssueFieldTextEditorProps = IssueFieldCommentEditorProps & {
  initialValue: string
  onCommit: (fieldId: string, value: string) => void
}

export const IssueFieldTextEditor = ({
  fieldId,
  fieldName,
  readonly,
  initialValue,
  onCommit,
  hideDivider,
}: IssueFieldTextEditorProps) => {
  const [text, setText] = useState(initialValue || '')

  const onBlur = () => {
    onCommit(fieldId, text)
  }

  return (
    <Section sectionHeader={<SectionHeader title={fieldName} readonly />} hideDivider={hideDivider}>
      <div style={{marginRight: 10}}>
        <TextInput
          aria-label={`The value for the ${fieldName} field`}
          readOnly={readonly}
          value={text}
          onChange={e => setText(e.target.value)}
          onBlur={onBlur}
          className={fieldEditorsStyles.fieldTextInput}
        />
      </div>
    </Section>
  )
}

try{ IssueFieldTextEditor.displayName ||= 'IssueFieldTextEditor' } catch {}